import React, { useEffect, useState } from 'react';
import { Layout, message } from 'antd';

import OrderService from 'services/order';
import DetailOrder from 'components/detail-order';
import { PageSpinner } from 'components/page-spinner';
import { errHandling } from 'utils';
import { get } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';

export const OrderDetail = () => {
  const [isRent, setIsRent] = useState(false);
  const [liveTracking, setliveTracking] = useState('');
  const [loadingModal, setLoadingModal] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [orderActivity, setOrderActivity] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [tracking, setTracking] = useState([]);
  const [value, setValue] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id');

  async function getOrder(withLoading = true) {
    try {
      if (withLoading) {
        setLoadingPage(true);
      }
      if (id) {
        const { data } = await OrderService.getOrderCollection(id);
        const orderDetail = data.data;
        setValue(orderDetail);
        const activity = await OrderService.getOrderCollectionActivity(id);
        setOrderActivity(activity.data.data);
        if (orderDetail.type === 'rent') setIsRent(true);
      }
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingPage(false);
    }
  }

  async function printInvoice(packageId) {
    setLoadingPrint(true);
    const { data } = await OrderService.getOrderShippingLabel(packageId);
    const shipping_label = get(data, 'data.shipping_label_url', '');
    setLoadingPrint(false);
    window.open(shipping_label);
  }

  async function findDriver(packageId) {
    try {
      setLoadingModal(true);
      await OrderService.findDriverGosend(packageId);
      getOrder();
    } catch (error) {
      errHandling(error);
    } finally {
      setShowModal(false);
      setLoadingModal(false);
    }
  }

  async function getTracking(id) {
    try {
      setLoadingModal(true);
      const { data } = await OrderService.getOrderTracking(id);
      const track = data.data;
      setTracking(track.manifest);
      setliveTracking(track.summary.live_tracking_url);
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingModal(false);
    }
  }

  async function confirmDelivery(packageId) {
    if (id) {
      try {
        await OrderService.confirmDelivery(packageId);
        await getOrder();
        message.success(
          `Order number ${get(value, 'id', '')} has been delivered`
        );
        if (isRent) navigate('/rent_orders');
        else if (value.user.role === 'business') navigate('/resellers_orders');
      } catch (err) {
        errHandling(err);
      }
    }
  }

  async function handleShipOrder(packageId) {
    try {
      setLoadingModal(true);
      await OrderService.shipOrder(packageId);
      getOrder();
    } catch (error) {
      errHandling(error);
    } finally {
      setShowModal(false);
      setLoadingModal(false);
    }
  }

  const createUpdateTrackHandler = async (key, tracking_code, packageId) => {
    if (key === 'create') {
      try {
        await OrderService.confirmShipment(packageId, tracking_code);
        setShowModal(false);
        getOrder();
      } catch (error) {
        errHandling(error);
      }
    } else {
      try {
        await OrderService.updateShipment(packageId, tracking_code);
        setShowModal(false);
        getOrder();
      } catch (error) {
        errHandling(error);
      }
    }
  };

  useEffect(() => {
    getOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (!id) {
      if (!isRent) {
        navigate({
          pathname: '/orders',
        });
      } else {
        navigate({
          pathname: '/rent_orders',
        });
      }
    }
    // eslint-disable-next-line
  }, [navigate, id]);

  if (loadingPage) {
    return <PageSpinner />;
  }

  return (
    <Layout className="main-container">
      <div className="content">
        <div className="pageTitle">
          {isRent ? 'Rent Detail' : 'Order Detail'}
        </div>
        <DetailOrder
          confirmDelivery={confirmDelivery.bind(this)}
          createUpdateTrackHandler={createUpdateTrackHandler}
          findDriver={findDriver.bind(this)}
          getOrder={getOrder.bind(this)}
          getTracking={getTracking}
          handleShipOrder={handleShipOrder.bind(this)}
          id={id}
          liveTracking={liveTracking}
          loadingModal={loadingModal}
          loadingPrint={loadingPrint}
          orderActivity={orderActivity}
          printInvoice={printInvoice.bind(this)}
          setLoadingModal={setLoadingModal}
          setLoadingPage={setLoadingPage}
          setOrderActivity={setOrderActivity}
          setShowModal={setShowModal}
          showModal={showModal}
          tracking={tracking}
          value={value}
        />
      </div>
    </Layout>
  );
};

export default { OrderDetail };
